"use strict";

var _defineProperty = require("/home/circleci/repo/node_modules/gatsby/node_modules/@babel/runtime/helpers/defineProperty");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

exports.__esModule = true;
exports.default = void 0;
var baseColors = {
  white: '#FFFFFF',
  offwhite: '#F5F5F5',
  greymid: '#D2D2D2',
  greydark: '#707070',
  offblack: '#262626',
  black: '#000000',
  success: '#008810',
  error: '#EB0023',
  none: 'transparent'
};
var colors = {
  horizon: _objectSpread(_objectSpread({}, baseColors), {}, {
    primary: '#6043C5',
    secondary: '#94FFD2',
    accent1: '#F9F9F9',
    accent2: '#FFD971'
  }),
  cannesLions: _objectSpread(_objectSpread({}, baseColors), {}, {
    primary: '#090972',
    secondary: '#F9D516',
    accent1: '#1E90FF',
    accent2: '#0F0D3C',
    accent3: '#638787'
  }),
  lionsLive: _objectSpread(_objectSpread({}, baseColors), {}, {
    primary: '#212121',
    secondary: '#E19F96',
    accent1: '#F6E2DF',
    accent2: '#00F7F0',
    accent3: '#638787',
    greymid: '#cdcdcd'
  }),
  money2020: _objectSpread(_objectSpread({}, baseColors), {}, {
    primary: '#000000',
    secondary: '#FF2161',
    accent1: '#FFE600',
    accent2: '#00F7F0'
  }),
  spikes: _objectSpread(_objectSpread({}, baseColors), {}, {
    primary: '#5B85AA',
    secondary: '#414770',
    accent1: '#372248',
    accent2: '#F46036'
  }),
  ascential: _objectSpread(_objectSpread({}, baseColors), {}, {
    primary: '#406450',
    secondary: '#004641',
    accent1: '#91BE23',
    accent2: '#F9BB21',
    greymid: '#E1E1D7',
    greydark: '#7C7C7C'
  }),
  dcl: _objectSpread(_objectSpread({}, baseColors), {}, {
    primary: '#003399',
    secondary: '#F7B74D',
    accent1: '#33CCCC',
    accent2: '#115C72',
    accent3: '#D4605D',
    accent4: '#660066',
    offwhite: '#EEEDEB',
    greymid: '#E1E1E1',
    black: '#141414'
  }),
  lionsCreativity: _objectSpread(_objectSpread({}, baseColors), {}, {
    primary: '#2E2E2E',
    secondary: '#F4F4F4',
    accent1: '#878A8A',
    accent2: '#D1B184',
    accent3: '#F9BE59',
    accent4: '#5C8788',
    accent5: '#4D8888'
  })
};
var _default = colors;
exports.default = _default;